import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Sidebar from "../../components/Navigation/Sidebar";
import Topbar from "../../components/Navigation/Topbar";
import Grid from "../../components/Grid";
import { connect } from "react-redux";
import { Button, Modal } from "react-bootstrap";
import { Show } from "../../hooks/Show";
import { useAuth } from "../../hooks/useAuth";
import Select from "../../components/AppSelect";

const MappingCustomer = ({
  reduxGetMappingCustomers,
  externalMappings,
  reduxGetMappingCustomer,
  externalMapping,
  reduxPostMappingCustomer,
  rowEdited,
  reduxDeleteMappingCustomer,
  rowDeleted,
  reduxPatchMappingCustomer,
  rowUpdated,
  reduxResetMappingCustomerForm,
  reduxGetCompanies,
  companies,
}) => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
    setValue,
    getValues
  } = useForm();
  const [currentPage, setCurrentPage] = useState(1);
  const [offset, setOffset] = useState(10);
  const { session } = useAuth();
  const [show, setShow] = useState(false);

  const handleClose = () => {
    reduxResetMappingCustomerForm();
    setShow(false);
  };
  const handleShow = () => {
    reduxResetMappingCustomerForm();
    reset();
    setShow(true);
  };
  const [search, setSearch] = useState("");

  const columns = [
    {
      title: "#",
      render: (rowData) => {
        return <span>{rowData.idExternalMapping}</span>;
      },
      field: 'idExternalMapping',
      searchable: true
    },
    {
      title: "Empresa",
      render: (rowData) => {
        return (
          <span>{rowData.company ? rowData.company.description : ""}</span>
        );
      },
      field: 'company.description',
      searchable: true
    },
    {
      title: "Cliente",
      render: (rowData) => {
        return (
          <span>
            {rowData.idEntity &&
            companies.items &&
            Object.keys(companies).length > 0
              ? companies.items
                  .filter((f) => f.isActive == true)
                  .filter((c) => c.idCompany == rowData.idEntity).length > 0
                ? companies.items
                    .filter((f) => f.isActive == true)
                    .filter((c) => c.idCompany == rowData.idEntity)[0]
                    .description
                : ""
              : ""}
          </span>
        );
      },
      field: 'company.description',
      searchable: true
    },
    {
      title: "ID Externo",
      render: (rowData) => {
        return <span>{rowData.idExternalEntity}</span>;
      },
      field: 'idExternalEntity',
      searchable: true
    },
    {
      title: "Opciones",
      render: (rowData) => {
        return (
          <>
            {rowData.isActive ? (
              <>
                <Show when="feature:edit-mapping-customers">
                  <button
                    title="Editar"
                    className="btn btn-primary btn-sm  btn-circle mr-2"
                    type="button"
                    onClick={(e) => handleOpen(rowData)}
                  >
                    <i className="fas fa-edit fa-xs"></i>
                  </button>
                </Show>
                <Show when="feature:disabled-mapping-customers">
                  <button
                    title="Desactivar"
                    className="btn btn-danger btn-sm btn-circle"
                    type="button"
                    onClick={(e) => handleDelete(rowData)}
                  >
                    <i className="fas fa-times-circle fa-xs"></i>
                  </button>
                </Show>
              </>
            ) : (
              <Show when="feature:enabled-mapping-customers">
                <button
                  title="Activar"
                  className="btn btn-primary btn-sm  btn-circle mr-2"
                  type="button"
                  onClick={(e) => handleActive(rowData)}
                >
                  <i className="fas fa-check-circle fa-xs"></i>
                </button>
              </Show>
            )}
          </>
        );
      },
    },
  ];

  const handleOpen = (row) => {
    reduxGetMappingCustomer({
      id: row.idExternalMapping,
    });
  };

  const handleActive = (row) => {
    if (!row.isActive) {
      reduxDeleteMappingCustomer(row);
    }
  };

  useEffect(() => {
    if (rowEdited) {
      setShow(true);
      const [selectedCompany] = (companies.items.filter((f)=>f.idCompany === rowEdited.idCompany));
      const [selectedClient] = (companies.items.filter((f)=>f.idCompany === rowEdited.idEntity));

      setValue("idEntity", {value: selectedClient.idCompany, label: selectedClient.description});
      setValue("idCompany", {value: selectedCompany.idCompany, label: selectedCompany.description});
      setValue("idExternalEntity", rowEdited.idExternalEntity);
    }
  }, [rowEdited]);

  const handleDelete = (row) => {
    reduxDeleteMappingCustomer(row);
  };

  useEffect(() => {
    reduxGetMappingCustomers({
      page: 1,
      offset: offset,
      search: "",
      mappingType: "company",
    });
    reduxGetCompanies({
      page: 1,
      search: "",
      offset: 1000,
    });
  }, []);

  useEffect(() => {
    reduxGetMappingCustomers({
      page: currentPage,
      offset: offset,
      search: search,
      mappingType: "company",
    });
  }, [currentPage]);

  const onSubmit = (data) => {
    if (rowEdited) {
      reduxPatchMappingCustomer({
        ...data,
        idExternalMapping: rowEdited.idExternalMapping,
        mappingType: "company",
        idCompany:
          session && session.role.idCompany
            ? session.role.idCompany
            : data.idCompany,
      });
    } else {
      reduxPostMappingCustomer({
        ...data,
        mappingType: "company",
        idCompany:
          session && session.role.idCompany
            ? session.role.idCompany
            : data.idCompany,
      });
    }
  };

  useEffect(() => {
    if (externalMapping || rowUpdated || rowDeleted) {
      if (
        (externalMapping && externalMapping.message == undefined) ||
        (rowUpdated && rowUpdated.message == undefined) ||
        rowDeleted
      ) {
        reduxGetMappingCustomers({
          page: currentPage,
          offset: offset,
          search: search,
          mappingType: "company",
        });
        reset();
        reduxResetMappingCustomerForm();
        setShow(false);
      }
    }
  }, [externalMapping, rowUpdated, rowDeleted]);

  return (
    <div>
      <div id="wrapper">
        <Sidebar />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Topbar />
            <div className="container-fluid">
              <div className="d-sm-flex align-items-center mb-1">
                <h1 className="h3 mb-0 text-gray-800 mr-3">
                  Mapeo clientes externos
                </h1>
                <Show when="feature:create-mapping-customers">
                  <button
                    className="btn btn-primary btn-circle"
                    type="button"
                    onClick={handleShow}
                  >
                    <i className="fas fa-plus fa-sm"></i>
                  </button>
                </Show>
              </div>
              <p className="mb-4">Módulo de Mapeo de clientes</p>
              <div className="card shadow mb-4">
                <div className="card-header py-3">
                  <h6 className="m-0 font-weight-bold text-primary">
                    Listado de Mapeo de clientes
                  </h6>
                </div>
                <div className="card-body">
                  <Grid
                    cols={columns}
                    data={
                      externalMappings &&
                      Object.keys(externalMappings).length > 0
                        ? externalMappings.items
                        : []
                    }
                    page={
                      externalMappings &&
                      Object.keys(externalMappings).length > 0
                        ? Number(externalMappings.page)
                        : currentPage
                    }
                    pages={
                      externalMappings &&
                      Object.keys(externalMappings).length > 0
                        ? Number(externalMappings.totalPages)
                        : 0
                    }
                    total={
                      externalMappings &&
                      externalMappings.hasOwnProperty("total")
                        ? externalMappings.total
                        : 0
                    }
                    offset={offset}
                    onChangePage={(page) => setCurrentPage(page)}
                    onChangeRange={(value) => {
                      setOffset(value);
                      reduxGetMappingCustomers({
                        page: 1,
                        offset: value,
                        search: search,
                        mappingType: "company",
                      });
                    }}
                    defaultValue={search}
                    onChangeSearch={(value) => {
                      setSearch(value);
                      reduxGetMappingCustomers({
                        page: 1,
                        offset: offset,
                        search: value,
                        mappingType: "company",
                      });
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <Modal
          show={show}
          onHide={handleClose}
          onEscapeKeyDown={handleClose}
          backdrop="static"
          keyboard={true}
        >
          <form onSubmit={handleSubmit(onSubmit)}>
            <Modal.Header closeButton>
              <Modal.Title>
                {rowEdited ? "Editar" : "Nuevo"} Mapeo de cliente
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {session && session.role.idCompany == null && (
                <div className="form-group">
                  <label htmlFor="idCompany" className="form-label">
                    Empresa
                  </label>
                  <Select
                    isClearable={true}
                    value={getValues('idCompany')}
                    {...register('idCompany')}
                    id='idCompany'
                    onChange={(value) => setValue('idCompany', value?.value || '')}
                    options=
                    {companies &&
                      Object.keys(companies).length > 0 &&
                      companies.items
                        .map((ele) => ({                                    
                            value: ele.idCompany,
                            label: ele.description,
                          }))
                    }
                  />
                  {errors.idCompany && (
                    <span className="invalid-feedback">
                      La empresa es requerida
                    </span>
                  )}
                </div>
              )}
              <div className="form-group">
                <label htmlFor="idEntity" className="form-label">
                  Cliente
                </label>
                <Select
                    isClearable={true}
                    value={getValues('idEntity')}
                    {...register('idEntity')}
                    id='idEntity'
                    onChange={(value) => setValue('idEntity', value?.value || '')}
                    options=
                    {companies &&
                      Object.keys(companies).length > 0 &&
                      companies.items
                        .map((ele) => ({                                    
                            value: ele.idCompany,
                            label: ele.description,
                          }))
                    }
                  />
                {errors.idEntity && (
                  <span className="invalid-feedback">
                    El cliente es requerido
                  </span>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="idExternalEntity" className="form-label">
                  ID externo
                </label>
                <input
                  id="idExternalEntity"
                  type="text"
                  className={`form-control form-control-user ${
                    errors.idExternalEntity && "is-invalid"
                  }`}
                  {...register("idExternalEntity", { required: true })}
                />
                {errors.idExternalEntity && (
                  <span className="invalid-feedback">El ID es requerido</span>
                )}
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Cancelar
              </Button>
              <Button variant="primary" type="submit">
                Guardar
              </Button>
            </Modal.Footer>
          </form>
        </Modal>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    externalMappings: state.externalMappingState.externalMappings,
    externalMapping: state.externalMappingState.externalMapping,
    rowEdited: state.externalMappingState.rowEdited,
    rowDeleted: state.externalMappingState.rowDeleted,
    rowUpdated: state.externalMappingState.rowUpdated,
    companies: state.companyState.companies,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    reduxGetMappingCustomers: (payload) =>
      dispatch({
        type: "FETCH_EXTERNALMAPPINGS_REQUEST",
        value: payload,
      }),
    reduxPostMappingCustomer: (payload) =>
      dispatch({
        type: "CREATE_EXTERNALMAPPING_REQUEST",
        value: payload,
      }),
    reduxGetMappingCustomer: (payload) =>
      dispatch({
        type: "READ_EXTERNALMAPPING_REQUEST",
        value: payload,
      }),
    reduxDeleteMappingCustomer: (payload) =>
      dispatch({
        type: "DELETE_EXTERNALMAPPING_REQUEST",
        value: payload,
      }),
    reduxPatchMappingCustomer: (payload) =>
      dispatch({
        type: "UPDATE_EXTERNALMAPPING_REQUEST",
        value: payload,
      }),
    reduxResetMappingCustomerForm: () =>
      dispatch({
        type: "RESET_EXTERNALMAPPING_FORM",
      }),
    reduxGetCompanies: (payload) =>
      dispatch({
        type: "FETCH_COMPANIES_REQUEST",
        value: payload,
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MappingCustomer);
